// extracted by mini-css-extract-plugin
export default {"canvasImage":"CanvasImage_canvasImage__hr3-9","downloadLink":"CanvasImage_downloadLink__wp2xc"};